"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var randomID = function randomID(name) {
  return "".concat(name + Math.floor(Math.random() * 100000), "-id-").concat(Math.floor(Math.random() * 100000));
};

var _default = randomID;
exports.default = _default;